import { Node } from 'slate'

import { IStyleInfo } from '../../interface/custom-types'

export function getDropdownFormatInSelectedNode<T>(
  selectedNode: Node,
  ketField: string,
  formats: IStyleInfo<T>[]
) {
  if (selectedNode && selectedNode[ketField]) {
    const selectedFiltersFromProps = formats.filter((item) => item.style === selectedNode[ketField])
    return selectedFiltersFromProps.length ? selectedNode[ketField] : ''
  }

  return ''
}
